import { type NexusSignal, otto } from "@otto-ec/global-resources/nexus";
import { toggle } from "@otto-ec/global-resources/toggle";
import type {
    RecoCinemasBounceLayerEventPayload,
    RecoCinemasWishlistEventPayload,
    RecoCinemasOrderOverviewEventPayload,
    DetailViewRenderRecommendationsEventPayload,
} from "@otto-ec/nexus-registry/reco/cinemas";

declare module "@otto-ec/nexus-registry/reco/cinemas" {
    interface RecoCinemasRaw {
        renderBounceLayerRecommendationsInternal: NexusSignal<RecoCinemasBounceLayerEventPayload>;
        renderWishlistRecommendationsInternal: NexusSignal<RecoCinemasWishlistEventPayload>;
        renderOrderOverviewRecommendationsInternal: NexusSignal<RecoCinemasOrderOverviewEventPayload>;
        renderAlternativeRecommendationsInternal: NexusSignal<DetailViewRenderRecommendationsEventPayload>;
        renderComplementaryRecommendationsInternal: NexusSignal<DetailViewRenderRecommendationsEventPayload>;
        renderProductLineRecommendationsInternal: NexusSignal<DetailViewRenderRecommendationsEventPayload>;
    }
}

export const {
    renderBounceLayerRecommendationsInternal,
    renderWishlistRecommendationsInternal,
    renderOrderOverviewRecommendationsInternal,
    renderAlternativeRecommendationsInternal,
    renderComplementaryRecommendationsInternal,
    renderProductLineRecommendationsInternal
} = otto.reco.cinemas;

export async function setUpInternalInterfaces() {
    if (!import.meta.env.SSR) {
        const {
            renderBounceLayerRecommendations,
            renderPdpRecommendations,
            renderWishlistRecommendations,
            renderOrderOverviewRecommendations,
        } = await import("@otto-ec/nexus-registry/reco/cinemas");
        if (toggle.get("ftsix_enable_bouncelayer_nexus_ssr")) {
            renderBounceLayerRecommendations.assignFunction((payload) => {
                renderBounceLayerRecommendationsInternal.set(payload);
            });
        }
        if (toggle.get("ftsix_enable_wishlist_nexus_ssr")) {
            renderWishlistRecommendations.assignFunction((payload) => {
                renderWishlistRecommendationsInternal.set(payload);
            });
        }
        if (toggle.get("ftsix_enable_orderoverview_nexus_ssr")) {
            renderOrderOverviewRecommendations.assignFunction((payload) => {
                renderOrderOverviewRecommendationsInternal.set(payload);
            });
        }
        if (toggle.get("ftsix_enable_pdp_nexus_ssr")) {
            renderPdpRecommendations.assignFunction((payload) => {
                if(!payload.target || payload.target === "alternative") {
                    renderAlternativeRecommendationsInternal.set(payload);
                } else if (payload.target === "complementary") {
                    renderComplementaryRecommendationsInternal.set(payload);
                } else if (payload.target === "productline") {
                    renderProductLineRecommendationsInternal.set(payload);
                }
            });
        }
    }
}
